import { render, staticRenderFns } from "./selectedChild.vue?vue&type=template&id=475a4a6f&scoped=true"
import script from "./selectedChild.vue?vue&type=script&lang=js"
export * from "./selectedChild.vue?vue&type=script&lang=js"
import style0 from "./selectedChild.vue?vue&type=style&index=0&id=475a4a6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a4a6f",
  null
  
)

export default component.exports